import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { ChevronLeft, CreditCard } from "lucide-react";
import CardCartao from "../../../../components/Authenticated/MinhaConta/MetodosDePagamento/CardCartao";
import BottomMenu from "../../../../components/common/Authenticated/Menu/Menu";
import api from "../../../../services/api";

const MetodosDePagamento = () => {
  const navigate = useNavigate();
  const [cartoes, setCartoes] = useState([]);
  const [loading, setLoading] = useState(true);

  const usuarioStorage = JSON.parse(localStorage.getItem("usuario")) || {};

  const Voltar = () => {
    navigate("/area-restrita/minha-conta");
  };

  const handlePress = () => {
    navigate("add");
  };

  const fetchCartoes = useCallback(async () => {
    if (!usuarioStorage._id) return;

    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      const { data } = await api.get(`cliente/cartoes/${usuarioStorage._id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });

      const cartoesData = data.cartao?.data?.data || [];
      setCartoes(cartoesData);

      if (cartoesData.length === 0) {
        console.log("Nenhum cartão encontrado");
      }
    } catch (err) {
      console.error("Erro ao buscar cartões:", err.message);
      setCartoes([]);
    } finally {
      setLoading(false);
    }
  }, [usuarioStorage._id]);

  useEffect(() => {
    fetchCartoes();
  }, [fetchCartoes]);

  return (
    <>
      {/* Botão de voltar */}
      <button
        onClick={Voltar}
        className="absolute top-3 left-2 bg-[#003D42] p-2 rounded-full z-10 flex items-center justify-center shadow-md w-9 hover:bg-[#002d30] transition"
      >
        <ChevronLeft size={20} color="#fff" />
      </button>

      <div className="min-h-screen flex flex-col justify-center items-center p-4 bg-gray-50 mt-[-50px]">
        <div className="w-full max-w-[600px]">
          {/* Título */}
          <div className="flex flex-col items-center text-center">
            <CreditCard size={40} className="text-[#003D42]" />
            <h2 className="text-xl font-bold text-gray-800">
              Seus métodos de pagamento
            </h2>
            <p className="text-gray-500 text-sm mt-1">
              Gerencie seus cartões de forma simples e segura
            </p>
          </div>

          {/* Lista de cartões */}
          {loading ? (
            <p className="mt-8 text-center text-gray-600">Carregando cartões...</p>
          ) : cartoes.length > 0 ? (
            <div className="mt-6 space-y-4">
              {cartoes.map((cartao) => (
                <CardCartao
                  key={cartao.id || cartao.card_id}
                  id={cartao.id || cartao.card_id}
                  ultimosNumeros={cartao.last_four_digits || cartao.last_digits}
                  onDeleteSuccess={fetchCartoes}
                />
              ))}
            </div>
          ) : (
            <div className="mt-8 text-center">
              <p className="text-gray-600">Nenhum cartão encontrado</p>
              <p className="text-sm text-gray-400">
                Adicione um novo cartão para começar
              </p>
            </div>
          )}

          {/* Botão adicionar */}
          <div className="mt-8">
            <button
              onClick={handlePress}
              className={`mt-6 w-full bg-[#003D42] text-white font-semibold py-3 rounded-md shadow-md hover:bg-[#002d30] transition ${
              loading ? "opacity-50 cursor-not-allowed" : ""
            }`}
            >
              + Adicionar cartão
            </button>
          </div>
        </div>
      </div>

      <BottomMenu />
    </>
  );
};

export default MetodosDePagamento;
